import React from 'react';
import styled from 'styled-components';
const StyledContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 8px;

  color: var(--color-text-main);
`;
export function FilterContainer({ children }) {
    return React.createElement(StyledContainer, null, children);
}
